<template>
  <w-sliding-popup ref="slidingPopup" :title="title" width="1100px" @close="closed">
    <component
    ref="deviceConnectDeviceInfoNode"
    :is="component"
    :nodeParams="nodeParams"
    :activeTab="activeTab"
    slot="content">
    </component>
  </w-sliding-popup>
</template>
<script>
import MapConst from '@/constants/topologymap';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WDeviceConnectDeviceInfoNode from '@/views/config/node/netdevice/connectdevice';

export default {
  name: 'WConnectDeviceInfoPopup',
  components: {
    WDeviceConnectDeviceInfoNode,
  },
  data() {
    return {
      component: null, // 완전 초기화를 위해 팝업창이 열리고 닫힐 때 컴포넌트를 생성/삭제 하는 방식으로 구현
      nodeParams: {},
      activeTab: '',
      objName: null,
    };
  },
  computed: {
    title() {
      return `[${this.objName || '-'}] 연결장비 정보`;
    },
  },
  created() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.CONNECT_DEVICE_INFO, this.open);
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.CONNECT_DEVICE_INFO, this.open);
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open(param) {
      this.$refs.slidingPopup.open();

      this.component = WDeviceConnectDeviceInfoNode;

      // getConnDeviceList() 에서 $refs를 가져올 때 undefined 오류를 방지하기 위한 $nextTick
      this.$nextTick(() => {
        netdeviceInfoAPI.getNetdeviceObjInfo({ objId: param.objId }).then((result) => {
          if (result.data.success) {
            if (param.connectInfoParam) {
              try {
                const { macaddress } = param.connectInfoParam;
                const deviceConnectDeviceInfoNode = this.$refs.deviceConnectDeviceInfoNode;
                const connDeviceTable = deviceConnectDeviceInfoNode.$refs.connDeviceTable;

                deviceConnectDeviceInfoNode.showSearchTool = true;
                connDeviceTable.states.searches.arpMacaddress = macaddress;
                connDeviceTable.states.filters.arpMacaddress = [macaddress];
              } catch (e) {
                // ignore
              }
            }
            this.nodeParams = result.data.data;
            this.activeTab = 'WDeviceConnectDeviceInfoNode';
            this.objName = result.data.data.objName;
          }
        });
      });
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업 닫힌 후 콜백
     * @author KangBonghun(toto1323)
     */
    closed() {
      this.component = null;
      this.activeTab = '';
      this.objName = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/ConnectDeviceInfoPopup.vue